import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import VerticalNav from '../../components/VerticalNav';
import PageHeader from '../../components/PageHeader';
import { useMedicalCenter } from '../../hooks/useMedicalCenter';
import { useOdontoCenter } from '../../hooks/useOdontoCenters';

import styles from './SwissMedicalCenterPage.module.scss';
import CustomSections from '../../components/Shared/Sections/CustomSections';

const SwissMedicalCenterPage = () => {
  const [tabKey, setTabKey] = useState('');

  const {
    links,
    components,
    key: medicalCenterKey,
    setKey: medicalCenterSetKey,
  } = useMedicalCenter();
  const {
    odonto_links,
    odonto_components,
    key: odontoKey,
    setKey: odontoSetKey,
  } = useOdontoCenter();

  const location = useLocation();

  useEffect(() => {
    const l = location.pathname.split('/').length;
    setTabKey(location.pathname.split('/')[l - 1]);
  }, [location.pathname]);

  const tabs = [
    {
      eventKey: 'swiss-medical-center',
      title: 'CENTROS MÉDICOS',
      child: (
        <VerticalNav
          links={links}
          comps={components}
          activeKey={medicalCenterKey}
          setActiveKey={medicalCenterSetKey}
        />
      ),
    },
    {
      eventKey: 'centros-odontologicos',
      title: 'CENTROS ODONTOLÓGICOS',
      child: (
        <VerticalNav
          links={odonto_links}
          comps={odonto_components}
          activeKey={odontoKey}
          setActiveKey={odontoSetKey}
        />
      ),
    },
  ];

  return (
    <div className={styles.swiss_medical_center_page}>
      <PageHeader title='Swiss Medical Center'>
        Nuestros <strong>Centros Médicos Ambulatorios</strong> cuentan con prestigiosos
        profesionales, cómodas instalaciones y la tecnología más avanzada para brindarle una
        excelente atención programada y/o de urgencia.
      </PageHeader>
      <p className={styles.swiss_medical_center_page__lead}>
        Para más información sobre servicios y horarios de atención ingrese en{' '}
        <a href='https://www.swissmedicalcenter.com.ar' target='__blank'>
          www.swissmedicalcenter.com.ar
        </a>
      </p>
      <CustomSections tabs={tabs} activeKey={tabKey} handleKey={setTabKey} />
    </div>
  );
};

export default SwissMedicalCenterPage;
